import { TStatusDotIcon } from '@components/StatusDot/StatusDot.interface';
import { TAdminSupplementInquiryStatus } from '@interfaces/adminSupplements';

const statusMap = {
  [TAdminSupplementInquiryStatus.New]: TStatusDotIcon.Red,
  [TAdminSupplementInquiryStatus.Recent]: TStatusDotIcon.Blue,
  [TAdminSupplementInquiryStatus.Other]: TStatusDotIcon.Yellow,
};

export const getStatusIcon = (value: TAdminSupplementInquiryStatus) => statusMap[value];
